import { Box, Button, Typography, Collapse, Divider, IconButton } from "@mui/material";
import { EVENT_SHIRO } from "../../pages/Home";
import { useState } from "react";
import { IoCalendarSharp } from "react-icons/io5";
import { GoClockFill } from "react-icons/go";
import { ImLocation } from "react-icons/im";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdDescription } from "react-icons/md";
import { TiMinus, TiPlus } from "react-icons/ti";
import ReactQuill from "react-quill";

const Ticket = ({
  type,
  event,
  price,
  onClick,
  ticketLeft,
  name,
  eventData,
  data,
  isSelected = false,
  quantity = 0,
  onIncrease,
  onDecrease,
  increaseDisabled = false,
}) => {
  const [expanded, setExpanded] = useState(false);
  const isShiroEvent = name === EVENT_SHIRO;

  // console.log(data, "TICKET");
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };

  // Helper function to truncate text
  const truncateText = (text, maxLength) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  return (
    <>
      <Box
        onClick={ticketLeft > 0 ? onClick : undefined}
        sx={{
          border: isSelected ? "2px solid #BC172F" : "1px solid #D9D9D9",
          borderRadius: "12px",
          py: "24px",
          px: "16px",
          mb: 2,
          cursor: ticketLeft > 0 ? "pointer" : "default",
          backgroundColor: isSelected ? "rgba(188, 23, 47, 0.04)" : "#fff",
          transition: "border 0.15s ease, background-color 0.15s ease",
        }}
      >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width:'100%',
              boxSizing:'border-box'
            }}
          >
            <Typography sx={{ fontWeight: 700, fontFamily: "optima" }}>
              {type}
            </Typography>
            {!isShiroEvent && (
              <Typography
                sx={{ fontWeight: 700, fontSize: "20px", fontFamily: "optima" }}
              >
                N{price.toLocaleString()}{" "}
              </Typography>
            )}
          </Box>

          {!expanded && (
            <Typography
              className="two-line-ellipsis"
              sx={{
                color: "#717171",
                fontSize: "12px",
                fontWeight: 300,
                display: "-webkit-box",
                width:'100%'
              }}
            >
              {event.replace(/<[^>]*>/g, "")}
            </Typography>
          )}

          <Box
            onClick={(e) => {
              e.stopPropagation();
              handleExpandClick();
            }}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              cursor: "pointer",
              "&:hover": {
                color: "#bc172f",
              },
              transition: "color 0.2s ease",
            }}
          >
            <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
              {expanded ? "Less Details" : "More Details"}
            </Typography>
            {expanded ? (
              <IoIosArrowUp size={12} />
            ) : (
              <IoIosArrowDown size={12} />
            )}
          </Box>

          {/* Expandable Details Section */}
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Box
              sx={{
                mt: 2,
                p: 2,
                bgcolor: "#f8f9fa",
                borderRadius: "8px",
                border: "1px solid #e9ecef",
              }}
            >
              {event && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    mb: 1.5,
                  }}
                >
                  <MdDescription
                    size={14}
                    color="#bc172f"
                    style={{ marginTop: "2px" }}
                  />
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      sx={{ fontSize: "10px", fontWeight: 600, color: "#333" }}
                    >
                      Description
                    </Typography>
                    <ReactQuill
                      className="custom-quill"
                      value={event}
                      readOnly={true}
                      style={{ fontSize: "12px" }}
                      theme={null}
                      modules={{ toolbar: false }}
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </Collapse>

          {ticketLeft > 0 ? (
            quantity > 0 ? (
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                  columnGap: 2,
                }}
              >
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    onDecrease && onDecrease();
                  }}
                  sx={{
                    borderRadius: 1,
                    border: "0.5px solid #1a1a1a",
                    fontSize: "14px",
                    fontWeight: 900,
                  }}
                >
                  <TiMinus />
                </IconButton>
                <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                  {quantity}
                </Typography>
                <IconButton
                  disabled={increaseDisabled}
                  onClick={(e) => {
                    e.stopPropagation();
                    onIncrease && onIncrease();
                  }}
                  sx={{
                    borderRadius: 1,
                    border: "0.5px solid #1a1a1a",
                    fontSize: "14px",
                    fontWeight: 900,
                  }}
                >
                  <TiPlus />
                </IconButton>
              </Box>
            ) : (
              <Button
                disabled={increaseDisabled}
                onClick={(e) => {
                  e.stopPropagation();
                  onIncrease && onIncrease();
                }}
                variant="contained"
                sx={{ px: 4, borderRadius: "8px", mt: 2, fontSize: "12px" }}
              >
                Book Now
              </Button>
            )
          ) : (
            <Button
              disabled
              variant="contained"
              sx={{ px: 4, borderRadius: "8px", mt: 2, fontSize: "12px" }}
            >
              Sold Out
            </Button>
          )}
       
      </Box>
    </>
  );
};

export default Ticket;
